import React, { useEffect } from 'react';

/**
 * Confirmation dialog for marking a prelead as Qualified or Unqualified (no delete styling).
 */
const PreleadQualifyConfirmModal = ({ open, onClose, onConfirm, message = '' }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    if (open) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9100] flex items-center justify-center bg-black/30 px-4 py-10"
      onClick={onClose}
      role="presentation">
      <div
        className="w-full max-w-md overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="prelead-qualify-confirm-title">
        <div className="border-b border-customBlue/15 bg-[#E9F5F6] px-5 py-3">
          <h2 id="prelead-qualify-confirm-title" className="text-base font-semibold text-customBlue">
            Please confirm
          </h2>
        </div>
        <p className="px-5 py-6 text-center text-[15px] leading-relaxed text-gray-800">{message}</p>
        <div className="flex justify-center gap-3 border-t border-gray-100 bg-gray-50/80 px-5 py-4">
          <button
            type="button"
            onClick={onClose}
            className="min-w-[6.5rem] rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50">
            No
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="min-w-[6.5rem] rounded-lg bg-customBlue px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-opacity hover:opacity-90">
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreleadQualifyConfirmModal;
